import React, {useState} from "react";
import { Input } from '@material-ui/core';
import { Paper } from "@material-ui/core";
import * as S from '../formStyle';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import * as Style from '../styles'


function MoneyBox({
    title,
    filterName,
    handleInputChange,
    valoresRespostas,
    isLoading,
    ordem,
    conteudoOnChange,
    disabledList,
    componenteWidth
}) {
  const classes = S.useStyles();

  return (
    <>
        <label className={classes.label}>{title}</label>
        <Paper className={classes.medium} style={{ width: `${componenteWidth}px` }} elevation={0}>
            <Style.MoneyDiv>
                <CurrencyTextField
                    value={valoresRespostas[ordem] !== '0,00' ? valoresRespostas[ordem]  : 0}
                    decimalCharacter=","
                    currencySymbol="R$"
                    disabled={isLoading || disabledList[ordem]}
                    modifyValueOnWheel={false}
                    InputProps={{
                        className: classes.inputCurrency,
                    }}
                    digitGroupSeparator="."
                    name={filterName}
                    onBlur={(e) => {
                        handleInputChange(e, ordem, e.target.value, conteudoOnChange)
                    }}
                />
            </Style.MoneyDiv>
        </Paper>
    </>
  );
}

export default MoneyBox;
